$(document).ready(function () {
    $('.contentblock-form').each(function(){
        let formContainer = $(this);
        if (formContainer) {
            let formPath = formContainer.data('form-path');
            if (formPath) {
                formContainer.load(formPath, function(responseTxt, statusTxt){
                    if(statusTxt === "success") {
                        formContainer.show();
                        let formData = formContainer.find('form')
                        $forms.push({
                            name: formData.attr('name'),
                            $el: formData,
                            validationUrl: formData.data('validation-url'),
                            conditions: {fields: [], pages: []},
                            modal: false,
                            modalTimeout: 0
                        });
                        reloadForms();
                    }
                });
            }
        }
    })
});